/*
 * How long a visitor stayed, and how far they read.
 *
 * Shopify counts sessions and pages but never duration, and duration is the
 * number that separates two failures which look identical in a report: the
 * visitor who read a product page for ninety seconds and did not buy, and the
 * visitor who left after three. The first has a price or trust objection. The
 * second was the wrong person to show the ad to. One is fixed by the page, the
 * other by the targeting, and a session count cannot tell you which you have.
 *
 * Deliberately anonymous. No cookie, no localStorage, no device id, nothing
 * written to the visitor's machine and nothing that links this page view to
 * the next one. That is what keeps it outside the consent banner: there is no
 * storage access to consent to, and nothing stored that could identify anyone.
 *
 * Time is counted only while the tab is visible. A page left open in a
 * background tab over lunch is not ninety minutes of reading, and counting it
 * as such would make every average useless.
 */
(function () {
  var API = location.hostname === 'localhost'
    ? '/api/public/pageview'
    : 'https://control.zoocare.se/api/public/pageview';

  /* Respect the browser's own signal. Do Not Track is advisory and widely
     ignored; ignoring it while claiming to be privacy-minded would be worse
     than not measuring at all. */
  if (navigator.doNotTrack === '1' || window.doNotTrack === '1') return;

  var start = Date.now();
  var visible = document.visibilityState === 'visible';
  var accrued = 0;                 // milliseconds actually spent looking
  var deepest = 0;                 // furthest scroll, as a percentage
  var sent = false;

  function tick() {
    if (visible) accrued += Date.now() - start;
    start = Date.now();
  }

  document.addEventListener('visibilitychange', function () {
    tick();
    visible = document.visibilityState === 'visible';
  });

  function measureScroll() {
    var doc = document.documentElement;
    var height = doc.scrollHeight - window.innerHeight;
    // A page shorter than the window is fully read the moment it loads.
    var pct = height <= 0 ? 100 : Math.round((window.scrollY / height) * 100);
    if (pct > deepest) deepest = Math.max(0, Math.min(100, pct));
  }
  window.addEventListener('scroll', measureScroll, { passive: true });
  measureScroll();

  /* The UTM tags come off the landing URL. Shopify keeps them through an
     internal navigation, so reading them per page is right: it attributes the
     product page someone browsed to, not just the page they arrived on. */
  function utm() {
    var q = new URLSearchParams(location.search);
    return {
      source: q.get('utm_source'),
      medium: q.get('utm_medium'),
      campaign: q.get('utm_campaign'),
      content: q.get('utm_content'),
    };
  }

  /* Shopify tells the theme what kind of page this is; the snippet passes it
     through. Knowing "product" from "collection" is the difference between
     "people leave the product pages" and "people never reach one". */
  function pageType() {
    var el = document.querySelector('[data-zc-page-type]');
    return el ? el.getAttribute('data-zc-page-type') : null;
  }

  function send() {
    if (sent) return;
    sent = true;
    tick();

    var body = JSON.stringify({
      path: location.pathname,
      pageType: pageType(),
      referrer: document.referrer || null,
      utm: utm(),
      seconds: Math.round(accrued / 1000),
      scrollPct: deepest,
      viewportW: window.innerWidth,
    });

    /* sendBeacon survives the page being closed, which is exactly when this
       fires. fetch with keepalive is the fallback; a plain fetch would be
       cancelled by the navigation it is trying to report. */
    if (navigator.sendBeacon) {
      navigator.sendBeacon(API, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(API, { method: 'POST', headers: { 'content-type': 'application/json' }, body: body, keepalive: true })
        .catch(function () { /* a lost measurement is not worth an error */ });
    }
  }

  /* pagehide is the reliable one on iOS, where unload often never fires.
     visibilitychange covers the tab being switched away from and never
     returned to. Both guard on `sent`, so a page reports once. */
  window.addEventListener('pagehide', send);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') send();
  });
}());
